import { render, staticRenderFns } from "./pageLoader.vue?vue&type=template&id=6a7aa0e3&scoped=true&"
import script from "./pageLoader.vue?vue&type=script&lang=js&"
export * from "./pageLoader.vue?vue&type=script&lang=js&"
import style0 from "./pageLoader.vue?vue&type=style&index=0&id=6a7aa0e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7aa0e3",
  null
  
)

export default component.exports